import axios from '../../axios';
import { toast } from 'react-toastify';
import { GET_LOGS, GET_ONE_LOG, UPDATE_LOGS } from '../types';

export const getLogs = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/logs/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_LOGS,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Vehicle. Please try again. :", err);
   }
};

export const updateLogs = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/logs/update', formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_LOGS, payload: res.data.data });

         setTimeout(() => {
            toast.success('Logs updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getSingleLog = (id, accessCode) => async (dispatch) => {
   try {
      const res = await axios.post(`/logs/id`, {
         accessCode: accessCode,
         id: id,
      });
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_LOG, payload: res.data.data });
      }
      return res.data.data;
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
